import React from 'react';
import { useTranslation } from 'react-i18next';

export const EnergySharingDiagram: React.FC = () => {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage?.split('-')[0] || i18n.language.split('-')[0] || 'fr';
  const videoSource = language === 'nl' ? '/images/hownl.mp4' : language === 'en' ? '/images/howen.mp4' : '/images/how.mp4';

  return (
    <div className="w-full max-w-6xl mx-auto">
      <video
        key={videoSource}
        src={videoSource}
        autoPlay
        loop
        muted
        playsInline
        className="w-full h-auto"
      />
    </div>
  );
};
